import { type Ref, type SVGProps, forwardRef } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    data-name='Broken Lines'
    viewBox='0 0 100 100'
    width='1em'
    height='1em'
    ref={ref}
    {...props}
  >
    <path d='M50 53.28a5 5 0 0 1-1.83-.35L3.44 35.18A5.64 5.64 0 0 1 0 29.83a5.63 5.63 0 0 1 3.43-5.34L48.18 6.73a5 5 0 0 1 3.65 0l44.73 17.76a5.63 5.63 0 0 1 3.44 5.34 5.64 5.64 0 0 1-3.44 5.35L51.82 52.93a5 5 0 0 1-1.82.35zM7.74 29.84 50 46.6l42.25-16.77L50 13.07zM50 93.62a4.85 4.85 0 0 1-1.83-.36L3.44 75.51a5.88 5.88 0 0 1 0-10.69A3.28 3.28 0 0 1 7.18 70L50 86.93l42.25-16.76-17.73-7A3.28 3.28 0 1 1 76.94 57l19.62 7.78a5.87 5.87 0 0 1 0 10.69l-44.74 17.8a5 5 0 0 1-1.82.35z' />
    <path d='M50 73.45a4.85 4.85 0 0 1-1.83-.36L3.44 55.35a5.88 5.88 0 0 1 0-10.69l19.63-7.79A3.28 3.28 0 1 1 25.48 43L7.74 50 50 66.76l42.82-17a3.27 3.27 0 0 1 3.74-5.12 5.86 5.86 0 0 1 0 10.68L51.82 73.1a5 5 0 0 1-1.82.35z' />
  </svg>
);
export const LibraryIcon = forwardRef(SvgComponent);
